import { Link } from '@tanstack/react-router';

import config from '@/config';
import { useNavbarIconUrl } from '@shared/lib/hooks';
import { useT } from '@shared/i18n';

export const NavbarIconLogo = () => {
	const { website } = config.build;
	const navbarIconUrl = useNavbarIconUrl();
	const t = useT();
	if (website) {
		return (
			// eslint-disable-next-line jsx-a11y/anchor-is-valid
			<a rel="noreferrer" href={website} target="_blank">
				<img src={navbarIconUrl} alt={t('common.logo')} />
			</a>
		);
	}
	return (
		<Link to={'/'}>
			<img src={navbarIconUrl} alt={t('common.logo')} />
		</Link>
	);
};
